export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    align: 'left',
    fixed: 'left',
    minWidth: 300,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayChannel') || '渠道',
    field: 'displayChannel',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayChannel' },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsQty') || '出货数量',
    field: 'goodsQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnQty') || '出货箱数',
    field: 'ctnQty',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '金额小计',
    field: 'subAmount',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnGrossWeight') || '单箱毛重 (KG)',
    field: 'ctnGrossWeight',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subGrossWeight') || '毛重小计 (KG)',
    field: 'subGrossWeight',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subCbm') || '体积CBM (m³)',
    field: 'subCbm',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_detailRemark') || '备注',
    field: 'detailRemark',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
]
